import $ from 'jquery';

export default class QuantityControls {
  constructor(theme, element, updateCart) {
    this.theme = theme;
    this.element = element;
    this.$element = $(this.element);
    this.$wrapper = this.$element.find('.quantity-controls');
    this.FADE_OUT_ANIMATION_DURATION = 800; // ms
    var self = this;

    this.$element.find('.quantity-controls button.qty-plus').off().on('click', function (e) {
      e.preventDefault();
      var qtyInput = $(this).closest('.quantity-controls').find('input.quantity-selector');
      var stockAmt = $(this).closest('.quantity-controls').data('stock-count');
      let inventoryPolicy = $(this).closest('.quantity-controls').data('inventory-policy');
      let inventoryManagement = $(this).closest('.quantity-controls').data('inventory-management');
      var errorMsg = $(this).parent().next();
      const val = parseInt(qtyInput.val().toString(), 10);

      if (stockAmt) {
        if (val < stockAmt || inventoryPolicy == "continue" || inventoryManagement != "shopify") {
          var newVal = val + 1;
        } else {
          errorMsg.removeClass('d-none');
          newVal = stockAmt;
        }
      } else {
        newVal = val + 1;
      }

      qtyInput.val(newVal);
      if (updateCart) {
        self.updateCartItem(newVal);
      }
    });

    this.$element.find('.quantity-controls button.qty-minus').off().on('click', function (e) {
      e.preventDefault();
      var qtyInput = $(this).closest('.quantity-controls').find('input.quantity-selector');
      const val = parseInt(qtyInput.val().toString(), 10);
      var stockAmt = $(this).closest('.quantity-controls').data('stock-count');
      let inventoryPolicy = $(this).closest('.quantity-controls').data('inventory-policy');
      let inventoryManagement = $(this).closest('.quantity-controls').data('inventory-management');
      var errorMsg = $(this).parent().next();
      var newQty = (val - 1 < 1) ? 1 : val - 1; // Never go below 1.
      qtyInput.val(newQty);

      if (stockAmt && newQty <= stockAmt && (inventoryPolicy == "continue" || inventoryManagement != "shopify")) {
        errorMsg.addClass('d-none');
      }

      if (updateCart) {
        self.updateCartItem(newQty);
      }
    });

    this.$element.find('input.quantity-selector').off().on('change', function (e) {
      var qtyInput = $(this).closest('.quantity-controls').find('input.quantity-selector');
      var stockAmt = $(this).closest('.quantity-controls').data('stock-count');
      let inventoryPolicy = $(this).closest('.quantity-controls').data('inventory-policy');
      let inventoryManagement = $(this).closest('.quantity-controls').data('inventory-management');
      var errorMsg = $(this).parent().next();
      var val = parseInt(e.currentTarget.value.toString(), 10);

      if (val > stockAmt && (inventoryPolicy !== "continue" || inventoryManagement == "shopify")) {
        qtyInput.val(stockAmt);
        errorMsg.removeClass('d-none');
      } else {
        qtyInput.val(val);
        errorMsg.addClass('d-none');
      }

      if (updateCart) {
        self.updateCartItem(val);
      }
    });
  }

  updatePrices = (response) => {
    var items = response.items;
    var subTotal = response.items_subtotal_price;
    var numRows = this.$element.find('.line-item').length;
    var responseNumRows = response.items.length;

    // Note: We don't currently construct the Cart page's rows dynamically
    //       (like we do in Cart drawer).
    //       If there are any discounts, or if a discount line item no longer applies,
    //       refresh the form to let the existing logic handle it
    //       since we may need to add/remove line items.
    if (response.total_discount > 0 || numRows !== responseNumRows) {
      // Quick fix: submit form (non-ajax)
      $('#update_quantities').click();
      return false;
    }

    response.items.forEach((item, index) => {
      var $row = this.$element.find('.id-' + item.id);

      if (response.total_discount === 0) {
        // Remove discount lines / divs
        $row.find('.cart-table-price').html('<div class="money">--</div>');
      }

      if ($row.length > 0) {
        // Item singular price.
        $row.find('.cart-table-price .money').html(this.theme.formatMoney(item.original_price));

        // Line item total.
        $row.find('.cart-table-line-price').html(this.theme.formatMoney(item.final_line_price));
      }
    });

    this.$element.find('#cart-total-final-price').html(this.theme.formatMoney(response.total_price));
  }

  updateCartItem = (num) => {
    this.$wrapper.addClass('cart-item-quantity-active');
    var fade = num <= 0;
    var delay = fade ? this.FADE_OUT_ANIMATION_DURATION : 0;

    // If number of items is 1, don't do anything. We still want to use the 'remove' link.
    if (num >= 1) {
      this.cartSetQuantity(delay).always(() => {
        this.$wrapper.removeClass('cart-item-quantity-active');
      });
    }
    else {
      this.$wrapper.removeClass('cart-item-quantity-active');
    }
  }

  cartSetQuantity = (delay) => {
    var deferred = $.Deferred();

    $('.cart-error-box').text('');

    $.ajax({
      type: "POST",
      url: '/cart/update.js',
      dataType: 'json',
      data: $('#cartform').serialize(),
    })
      .then((data) => {
        deferred.resolve();
        setTimeout(() => {
          this.updatePrices(data);
        }, delay);
      })
      .fail((jqXHR, textStatus, errorThrown) => {
        deferred.reject();
        console.error('Cart error', textStatus, jqXHR, errorThrown);
        $('.cart-error-box').empty().text('Unable to update item quantity');
      });

    return deferred;
  }


}
